import { ReactNode } from 'react'
import Header from '@/presentation/components/common/Header'
import { Period } from '@/core/shared/types/dashboard'

interface DashboardLayoutProps {
  children: ReactNode
  selectedPeriod: Period
  onPeriodChange: (period: Period, customDates?: { startDate: string; endDate: string }) => void
  onRefresh: () => void
  lastUpdatedAt?: string
  isRefreshing?: boolean
}

export function DashboardLayout({
  children,
  selectedPeriod,
  onPeriodChange,
  onRefresh,
  lastUpdatedAt,
  isRefreshing,
}: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-background dark:bg-background_dark">
      <div className="sticky top-0 z-50 bg-background dark:bg-background_dark border-b shadow-sm">
        <Header
          title="Painel Sócio-Colaborador"
          subtitle="Gerencie suas comissões e motoristas"
          selectedPeriod={selectedPeriod}
          onPeriodChange={onPeriodChange}
          onRefresh={onRefresh}
          lastUpdatedAt={lastUpdatedAt}
          isRefreshing={isRefreshing}
          showShareButton={true}
        />
      </div>
      <div className="flex-grow">{children}</div>
    </div>
  )
}
